import { Accordion } from '@material-ui/core'
import React, { useContext, useState, useEffect } from 'react'
import { FileContext } from 'src/containers/Application/Files/Context'
import { getFilesByMainKind } from '@flatsy/utils/Functions/Files/GetFilesByKind'
import {
  getMainKindStatus,
  hasOneFileWithError,
} from '@flatsy/utils/Functions/Files/GetMainKindStatus'
import { FilesKind, KindDescription } from '@flatsy/types/Files/Kind'
import i18n from '@flatsy/utils/translations'
import { FilesMainKind as FilesMainType } from '@flatsy/types/Files'
import { useStyles } from './Style'
import Header from './Header'
import Detail from './Detail'
import { IFilesListItem } from './Type'

const FilesMainKind: React.FC<IFilesListItem> = ({ requiredFile }): React.ReactElement => {
  const classes = useStyles()
  const {
    files: { filesByApplicant },
    applicants: { current },
  } = useContext(FileContext)
  const filesByKind = getFilesByMainKind(filesByApplicant, requiredFile.kind)
  const hasError = hasOneFileWithError({ files: filesByKind })
  const [expanded, setExpanded] = useState(false)
  const onAccordionClick = (_: any, isExpanded: boolean) => {
    setExpanded(isExpanded)
  }

  const getMainKindTranslate = (title: FilesMainType) => {
    switch (title) {
      case FilesMainType.OTHER:
        return i18n.t('others')
      case FilesMainType.PROOF_OF_ID:
        return i18n.t('proof_of_id')
      case FilesMainType.PROOF_OF_RESIDENCE:
        return i18n.t('proof_of_residence')
      case FilesMainType.PROOF_OF_WORK:
        return i18n.t('proof_of_employment')
      case FilesMainType.PROOF_OF_REVENUE:
        return i18n.t('proof_of_income')
      case FilesMainType.TAX_NOTICE:
        return i18n.t('tax_notice')
      default:
        return title
    }
  }

  const getDescription = (): string => {
    const descriptions: string[] = []
    let hasEmptyString = false
    requiredFile.required.forEach((required) => {
      if (required.kind && KindDescription[required.kind] !== '') {
        switch (required.kind) {
          case FilesKind.PROOF_OF_ID_IDENTITY_CARD:
            descriptions.push(i18n.t('id_card'))
            break
          case FilesKind.PROOF_OF_ID_PASSPORT:
            descriptions.push(i18n.t('passport'))
            break
          case FilesKind.PROOF_OF_ID_DRIVING_LICENCE:
            descriptions.push(i18n.t('driving_licence'))
            break
          case FilesKind.PROOF_OF_ID_RESIDENCE_PERMIT:
            descriptions.push(i18n.t('residence_card'))
            break
          case FilesKind.PROOF_OF_RESIDENCE_RENT:
            descriptions.push(i18n.t('rent_receipt'))
            break
          case FilesKind.PROOF_OF_RESIDENCE_HOSTED:
            descriptions.push(i18n.t('certificate_of_accommodation'))
            break
          case FilesKind.PROOF_OF_RESIDENCE_OWNER:
            descriptions.push(i18n.t('property_tax'))
            break
          case FilesKind.PROOF_OF_WORK_CERTIFICATE:
            descriptions.push(i18n.t('proof_of_employment'))
            break
          case FilesKind.PROOF_OF_REVENUE_SALARY:
            descriptions.push(i18n.t('pay_slip'))
            break
          case FilesKind.TAX_NOTICE:
            descriptions.push(i18n.t('last_tax_notice'))
            break
          default:
            descriptions.push(required.kind)
        }
        return descriptions
      }
      if (KindDescription[required.kind] === '') {
        hasEmptyString = true
      }
    })
    return `${descriptions.join(', ')}${hasEmptyString ? '...' : ''}`
  }

  useEffect(() => {
    setExpanded(hasError)
  }, [hasError])

  return (
    <Accordion className={classes.container} expanded={expanded} onChange={onAccordionClick}>
      <Header
        status={getMainKindStatus({ files: filesByKind, requiredUpload: requiredFile })}
        title={getMainKindTranslate(requiredFile.kind)}
        description={getDescription()}
        files={filesByKind}
        required={current?.required_uploads}
      />
      <Detail files={filesByKind} />
    </Accordion>
  )
}

export default FilesMainKind
